export default {
  addressRules: [
    (v) => !!v || 'Required',
    //v => /^[A-Za-z0-9 \,\-\.\#]+$/.test(v) || 'Contains invalid characters',
    (v) => /.{0,100}$/.test(v) || 'Maximum length is 100 characters'
  ],
  emailAddressRules: [
    (v) => !!v || 'Email Address is required',
    (v) =>
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) || 'Email Address Does Not Have a Valid Format',
    (v) => /^.{0,256}$/.test(v) || 'Maximum email length is 256 characters'
  ],
  emailAddressArrayRules: [
    (v) => (Array.isArray(v) && v.length > 0) || 'Email Address is required',
    (v) =>
      (Array.isArray(v) &&
        v.every((w) => {
          return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            w
          );
        })) ||
      'An email Address Does Not Have a Valid Format',
    (v) =>
      (Array.isArray(v) &&
        v.every((w) => {
          return /^.{0,256}$/.test(w);
        })) ||
      'Maximum length is 256 characters for each email'
  ],
  fileRules: [(v) => !!v || 'Required', (v) => !v || v.size < 2000000 || 'File size should be less than 2 MB.'],
  jobTitleRules: [
    (v) => !!v || 'Required',
    //v => /^[A-Za-z0-9\.\,\# ]+$/.test(v) || 'Contains invalid characters',
    (v) => /^.{0,100}$/.test(v) || 'Maximum length is 50 characters'
  ],
  messageRules: [(v) => !!v || 'Required'],
  nameRules: [
    (v) => !!v || 'Required',
    (v) => /^[A-Za-z0-9\.\,\- _]+$/.test(v) || 'Contains invalid characters',
    (v) => /^.{0,50}$/.test(v) || 'Maximum length is 50 characters'
  ],
  organizationNameRules: [
    (v) => !!v || 'Required',
    (v) => /^[A-Za-z0-9 _\-]+$/.test(v) || 'Contains invalid characters',
    (v) => /^.{0,50}$/.test(v) || 'Maximum length is 50 characters'
  ],
  phoneRules: [
    (v) => !!v || 'Required',
    (v) => /^[A-Za-z0-9 \(\)\-\.]+$/.test(v) || 'Contains invalid characters',
    (v) => /^.{0,50}$/.test(v) || 'Maximum length is 50 characters'
  ],
  integerRules: [(v) => !!v || 'Required', (v) => parseInt(v) >= 0 || 'Must enter a number'],
  requiredRules: [(v) => !!v || 'Required'],
  emailSubjectRules: [
    (v) => !!v || 'Required',
    (v) => /^[A-Za-z0-9 _\-@!:#&*+,]+$/.test(v) || 'Contains invalid characters',
    (v) => /^.{0,100}$/.test(v) || 'Maximum length is 100 characters'
  ]
};
